import React, { useEffect, useState } from "react";
import { Navigate, useParams } from "react-router-dom";
import { useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { capture_program_answers, getAllProgramQuestions, getAllQuestions } from "../api/Users";
import { toast } from "react-toastify";
import Spinner from "../components/Loader/Spinner";
import ArrowBackIosIcon from "@mui/icons-material/ArrowBackIos";

const FillProgramQuestion = () => {
  const { id } = useParams();
  const [isLoading, setIsLoading] = useState(false);
  const { t } = useTranslation();
  const Navigate = useNavigate();

  const [filteredData, setFilteredData] = useState([]);
  const [filledData, setFilledData] = useState([]);
  const [fill, setFill] = useState(filledData);

  const typeObj = {
    input: 0,
    image: 1,
    radio: 2,
  };

  useEffect(() => {
    getQuestions();
  }, []);

  const getQuestions = () => {
    setIsLoading(true);
    getAllProgramQuestions(id)
      .then((res) => {
        if (res.status === "success") {
          const questions = res.data.Result;
          setFilteredData(questions);
          setIsLoading(false);
        } else {
          setIsLoading(false);
          toast.error("Failed to fetch questions");
        }
      })
      .catch((error) => {
        toast.error("Something went wrong");
        setIsLoading(false);
      });
  };

  const getBase64 = (file) => {
    return new Promise((resolve) => {
      let fileInfo;
      let baseURL = "";
      let reader = new FileReader();
      reader.readAsDataURL(file);

      reader.onload = () => {
        console.log("Called", reader);
        baseURL = reader.result;
        console.log(baseURL);
        resolve(baseURL);
      };
    });
  };

  const handleInputChange = async (e, val, index) => {
    const { name, value, type, files } = e.target;
    if (type !== "file") {
      const newRow = {
        program_id: id,
        type: val.type,
        question_id: val.id,
        answers: value,
      };
      setFill([...fill, newRow]);
      setFilledData([...filledData, newRow]);
    } else {
      const file = files[0];
      const base64String = await getBase64(file);

      const newRow = {
        program_id: id,
        type: val.type,
        question_id: val.id,
        answers: base64String,
      };
      setFill([...fill, newRow]);
      setFilledData([...filledData, newRow]);
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setIsLoading(true);
    console.log(filledData);

    const postData = {
      program_id: id,
      type: filledData.map((row) => row.type),
      question_id: filledData.map((row) => row.question_id),
      answers: filledData.map((row) => row.answers),
    };

    try {
      const response = await capture_program_answers(postData);
      if (response.status === "success") {
        setIsLoading(false);
        toast.success(response.message);
        setTimeout(() => {
          window.location.reload();
        }, 1000);
      } else {
        toast.error(response.message);
        setIsLoading(false);
      }
    } catch (error) {
      console.error("Error adding hostel requirement:", error);
      setIsLoading(false);
    }
  };

  useEffect(() => {
    getQuestions();
  }, []);
  const handleOnBack = (e) => {
    Navigate(-1);
  };
  return (
    <div className="container">
      <h5 className="my-3 my-5">{t("Fill Program")}</h5>
      {isLoading ? (
        <Spinner />
      ) : (
        <form>
          {filteredData.map((val, index) => (
            <div key={index} className="m-2 mt-3 card px-5">
              <span className="fs-4 my-4">
                <strong>{index + 1}.</strong> {val.question}
              </span>
              {val.type === typeObj.input && (
                <div className="my-4 col-12">
                  <textarea
                    name="answers"
                    className="form-control rounded"
                    id={`answer${index + 1}`}
                    placeholder="Type your answer here..."
                    onBlur={(e) => handleInputChange(e, val, index)}
                  />
                </div>
              )}
              {val.type === typeObj.image && (
                <div className="my-4 col-4">
                  <label
                    htmlFor={`imageUpload${index + 1}`}
                    className="form-label"
                  >
                    {t("Upload Image")}:
                  </label>
                  <input
                    name="answers"
                    type="file"
                    className="form-control"
                    id={`imageUpload${index + 1}`}
                    accept="image/*"
                    onChange={(e) => handleInputChange(e, val, index)}
                  />
                </div>
              )}
              {val.type === typeObj.radio && (
                <div className="my-4 col-4">
                  {JSON.parse(val.options).map((option, optionIndex) => (
                    <div key={optionIndex} className="form-check mb-3">
                      <input
                        className="form-check-input"
                        type="radio"
                        name="answers"
                        id={`option${optionIndex}`}
                        value={option}
                        onChange={(e) => handleInputChange(e, val, index)}
                      />
                      <label
                        className="form-check-label"
                        htmlFor={`option${optionIndex}`}
                      >
                        {option}
                      </label>
                    </div>
                  ))}
                </div>
              )}
            </div>
          ))}
          <div className="col-12 d-flex justify-content-end p-3">
            <button
              type="button"
              onClick={handleSubmit}
              className="btn btn-primary me-2"
            >
              {t("Submit")}
            </button>
          </div>
        </form>
      )}
    </div>
  );
};

export default FillProgramQuestion;
